import React, { Fragment, type ReactNode } from 'react';

import styled from 'styled-components';
import Markdown from 'marked-react';

import { Link } from '@grnhse/seedling/lib/birch/typography';

import { useChatTypewriter } from './use_chat_typewriter';
import {
  assistantMessageBubbleStyles,
  assistantMessageContentStyles,
} from './message_styles';

type Props = {
  content: string;
  animate?: boolean;
};

function safeHttpsUrl(href?: string): string {
  try {
    const url = new URL(href ?? '');
    return url.protocol === 'https:' ? href ?? '#' : '#';
  } catch {
    return '#';
  }
}

const renderer = {
  link(this: { elementId: string }, href: string, text: ReactNode) {
    const safe = safeHttpsUrl(href);
    return (
      <Link
        key={this.elementId}
        href={safe}
        rel="noopener noreferrer"
        target="_blank"
      >
        {text}
      </Link>
    );
  },
  image(this: { elementId: string }) {
    return <Fragment key={this.elementId} />;
  },
};

export function AssistantMessage({ content, animate = true }: Props) {
  const debouncedContent = useChatTypewriter(content, 360, animate);

  return (
    <Container>
      <Bubble>
        <Markdown renderer={renderer}>{debouncedContent}</Markdown>
      </Bubble>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const Bubble = styled.div`
  ${assistantMessageBubbleStyles}
  ${assistantMessageContentStyles}
`;
